import React from 'react';
import { Check, X } from 'lucide-react';

const SPECIALS = `!"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~`;

// Mirrors backend/services/lms/student_auth.py password_problems()
export const passwordRules = (pw = '') => [
  { key: 'len', label: 'At least 10 characters', ok: pw.length >= 10 },
  { key: 'upper', label: 'An uppercase letter (A–Z)', ok: /[A-Z]/.test(pw) },
  { key: 'lower', label: 'A lowercase letter (a–z)', ok: /[a-z]/.test(pw) },
  { key: 'num', label: 'A number (0–9)', ok: /\d/.test(pw) },
  { key: 'sym', label: 'A symbol (e.g. ! @ # $ %)', ok: [...pw].some((c) => SPECIALS.includes(c)) },
  { key: 'edge', label: 'No spaces at the start or end', ok: pw === pw.trim() },
];

export const passwordValid = (pw) => pw.length <= 128 && passwordRules(pw).every((r) => r.ok);

export const PasswordRules = ({ password }) => (
  <ul className="space-y-1 text-xs" data-testid="password-rules">
    {passwordRules(password).map((r) => (
      <li key={r.key} className={`flex items-center gap-1.5 ${r.ok ? 'text-green-700' : 'text-zinc-500'}`} data-testid={`password-rule-${r.key}-${r.ok ? 'ok' : 'missing'}`}>
        {r.ok ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}{r.label}
      </li>
    ))}
  </ul>
);
